
/**
 * API Keys Tab Help Content
 */
const APIKeysHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          API Keys
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          API keys authenticate your applications and agents with Aivilo Lens. Use them to securely access prompts, datasets, and send telemetry data.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Creating API Keys
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Click "Create API Key" and provide:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Name</span>: A descriptive name (e.g., "Production Agent")</p>
          <p>&#8226; <span className="font-medium">Description</span>: Optional notes about usage</p>
          <p>&#8226; <span className="font-medium">Scopes</span>: Permissions the key will have</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Available Scopes
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">read:prompts</span>: Fetch prompts from registry</p>
          <p>&#8226; <span className="font-medium">read:datasets</span>: Access test datasets</p>
          <p>&#8226; <span className="font-medium">read:configs</span>: Read configuration values</p>
          <p>&#8226; <span className="font-medium">write:telemetry</span>: Send traces and metrics</p>
          <p>&#8226; <span className="font-medium">write:evaluations</span>: Upload evaluation results</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Security Best Practices
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; Never commit API keys to version control</p>
          <p>&#8226; Use environment variables or secret managers</p>
          <p>&#8226; Create separate keys for different environments</p>
          <p>&#8226; Revoke unused or compromised keys immediately</p>
          <p>&#8226; Use minimum required scopes for each key</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Key Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Monitor key usage and last activity. Revoke keys that are no longer needed or show suspicious activity. Revoked keys cannot be restored.
        </p>
      </div>

      <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-500">
          See the <span className="font-medium">SDK Integration</span> tab for code examples using API keys.
        </p>
      </div>
    </>
  );
};

export default APIKeysHelp;
